import { render, staticRenderFns } from "./Exibir.vue?vue&type=template&id=21680870&scoped=true&"
import script from "./Exibir.vue?vue&type=script&lang=js&"
export * from "./Exibir.vue?vue&type=script&lang=js&"
import style0 from "./Exibir.vue?vue&type=style&index=0&id=21680870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21680870",
  null
  
)

export default component.exports